module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-04.84e694f3.svg";